'use client'

import { useEffect } from 'react'
import { captureUtmFromUrl } from '@/shared/lib/utm'

/**
 * Невидимый компонент. Монтируется один раз, фиксирует UTM из URL
 * и сохраняет в sessionStorage. Работает при любом переходе на страницу с UTM.
 */
export function UtmCapture() {
  useEffect(() => {
    captureUtmFromUrl(new URL(window.location.href))
  }, [])

  return null
}
